import { Link, Typography } from "@mui/material"
import { useOkCancelContext } from "lib/@hooks/useOkCancelContext"
import { navigateScheduleEditor } from "authoring/routes/project/utilities/project-navigation"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"

export function MissingAmendsDialogLine({ item, line, projectId, scheduleId }) {
    const label = item?.label ?? line
    const amendsKey = item?.amendsKey
    const canLink = amendsKey && projectId && scheduleId
    const { cancel } = useOkCancelContext()

    return (
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
            <If truthy={!!canLink}>
                <Link sx={{ cursor: "pointer", color: "inherit" }} onClick={handleClick} data-cy="missing-amend-link">
                    {label}
                </Link>
                <Else>{label}</Else>
            </If>
        </Typography>
    )

    function handleClick() {
        cancel()
        navigateScheduleEditor({ projectId, scheduleId, openAmend: amendsKey })
    }
}
